import { BannerSize } from '../types';

export const BANNER_SIZES: BannerSize[] = [
  // Square formats
  { 
    id: 'square-1080', 
    name: '1080×1080', 
    width: 1080, 
    height: 1080, 
    category: 'square',
    elements: [],
    lastModified: new Date()
  },
  { 
    id: 'square-600', 
    name: '600×600', 
    width: 600, 
    height: 600, 
    category: 'square',
    elements: [],
    lastModified: new Date()
  },
  
  // Horizontal formats
  { 
    id: 'horizontal-300x250', 
    name: '300×250', 
    width: 300, 
    height: 250, 
    category: 'horizontal',
    elements: [],
    lastModified: new Date()
  },
  { 
    id: 'horizontal-320x100', 
    name: '320×100', 
    width: 320, 
    height: 100, 
    category: 'horizontal',
    elements: [],
    lastModified: new Date()
  },
  { 
    id: 'horizontal-336x280', 
    name: '336×280', 
    width: 336, 
    height: 280, 
    category: 'horizontal',
    elements: [],
    lastModified: new Date()
  },
  { 
    id: 'horizontal-600x500', 
    name: '600×500', 
    width: 600, 
    height: 500, 
    category: 'horizontal',
    elements: [],
    lastModified: new Date()
  },
  { 
    id: 'horizontal-1800x663', 
    name: '1800×663', 
    width: 1800, 
    height: 663, 
    category: 'horizontal',
    elements: [],
    lastModified: new Date()
  },
  { 
    id: 'horizontal-1920x300', 
    name: '1920×300', 
    width: 1920, 
    height: 300, 
    category: 'horizontal',
    elements: [],
    lastModified: new Date()
  },
  { 
    id: 'horizontal-1920x1080', 
    name: '1920×1080', 
    width: 1920, 
    height: 1080, 
    category: 'horizontal',
    elements: [],
    lastModified: new Date()
  },
  
  // Vertical formats
  { 
    id: 'vertical-300x600', 
    name: '300×600', 
    width: 300, 
    height: 600, 
    category: 'vertical',
    elements: [],
    lastModified: new Date()
  },
  { 
    id: 'vertical-700x800', 
    name: '700×800', 
    width: 700, 
    height: 800, 
    category: 'vertical',
    elements: [],
    lastModified: new Date()
  },
  { 
    id: 'vertical-700x2000', 
    name: '700×2000', 
    width: 700, 
    height: 2000, 
    category: 'vertical',
    elements: [],
    lastModified: new Date()
  }
];

export const DEFAULT_SIZE = BANNER_SIZES[0];